exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3MAsR8LoIhFkdjd-yscG31 {\n  display: grid;\n  grid-template-columns: repeat(3, auto);\n  grid-gap: 20px;\n}\n", ""]);
// Exports
exports.locals = {
	"container": "_3MAsR8LoIhFkdjd-yscG31"
};